import React from 'react';
import {classes, style} from './dopp-layout-jumping-arrow.st.css';
import {Values} from '@wix/devzai-utils-common';
import {Button, Icon} from '@wix/devzai-utils-react';
import {FlexLayout} from '@wix/devzai-common-client';
import {DoppeViewerAppIconArrowDownMedium} from '../../../doppe-viewer-icons/doppe-viewer-icons';


export const DoppLayoutJumpingArrowSkin = {
    Small: 'small',
    Medium: 'medium',
} as const;

export type DoppLayoutJumpingArrowSkin = Values<typeof DoppLayoutJumpingArrowSkin>;

export const DoppLayoutJumpingArrow = React.memo(function DoppLayoutJumpingArrow(props: DoppLayoutJumpingArrow.Props) {
    const {
        className,
        skin = DoppLayoutJumpingArrowSkin.Medium,
        ...htmlAttributes
    } = props;

    return (
        <Button
            {...htmlAttributes}
            className={style(classes.root, {
                skin: skin
            }, className, FlexLayout.centerContent)}
        >
            <Icon
                className={style(classes.prefixIcon, {})}
                icon={DoppeViewerAppIconArrowDownMedium}
            />
        </Button>
    )
});

export namespace DoppLayoutJumpingArrow {

    export interface Props extends React.HTMLAttributes<any> {
        skin?: DoppLayoutJumpingArrowSkin;
    }
}